module.exports = __webpack_public_path__ + "img/cert1.2c3b0d7d.jpg";